import { useIonToast } from "@ionic/react";
import { useTranslation } from "react-i18next";

export const useSiteToaster = () => {
  const { t } = useTranslation();

  const [showToast] = useIonToast();
  const successMessage = t("site.download.successMessage");
  const errorMessage = t("site.download.errorMessage");

  const showSiteToaster = (message: string, color: string) =>
    showToast({ message, duration: 5_000, position: "top", color: color });

  const showSuccessMessage = () => showSiteToaster(successMessage, "success");

  const showErrorMessage = () => showSiteToaster(errorMessage, "danger");

  return {
    showSuccessMessage,
    showErrorMessage,
  };
};
